import { render, staticRenderFns } from "./MentionsLegales.vue?vue&type=template&id=593e4d3b&scoped=true&"
import script from "./MentionsLegales.vue?vue&type=script&lang=ts&"
export * from "./MentionsLegales.vue?vue&type=script&lang=ts&"
import style0 from "./MentionsLegales.vue?vue&type=style&index=0&id=593e4d3b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593e4d3b",
  null
  
)

export default component.exports